import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import VideoCard from '@/components/feature/VideoCard';
import ArticleCard from '@/components/feature/ArticleCard';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';
import { videos } from '@/mocks/videos';
import { articles } from '@/mocks/articles';

export default function Home() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);
  const newVideos = videos.filter((v) => v.isNew).slice(0, 8);
  const latestArticles = articles.slice(0, 3);

  return (
    <>
      <SEOHead
        title="麻豆影视在线观看·影视视频 | 在线看电影电视剧全集免费不缓冲"
        description="麻豆影视在线观看提供海量高清电影电视剧全集免费在线播放，即点即播无需下载，流畅不缓冲。涵盖动作片、喜剧片、爱情片、科幻片、恐怖片、动漫等丰富影视资源，每日更新最新热播内容。"
        keywords="麻豆影视在线观看,影视视频,在线看电影,在线看电视剧,在线影视网站,在线播放平台,在线视频观看,免费电影在线观看"
        canonicalUrl="https://www.madouys.com/"
        ogImage="https://readdy.ai/api/search-image?query=Chinese%20online%20movie%20streaming%20platform%20homepage%20hero%2C%20cinematic%20film%20reel%20with%20warm%20lighting%2C%20modern%20minimalist%20design%2C%20entertainment%20atmosphere&width=1200&height=630&seq=home-og-01&orientation=landscape"
      />
      <SchemaOrg type="WebSite" data={{ name: '麻豆影视', url: 'https://www.madouys.com/', potentialAction: { '@type': 'SearchAction', target: 'https://www.madouys.com/search?q={search_term_string}', 'query-input': 'required name=search_term_string' } }} />
      <SchemaOrg type="WebPage" data={{ name: '麻豆影视 - 首页', url: 'https://www.madouys.com/', isPartOf: { '@type': 'WebSite', name: '麻豆影视', url: 'https://www.madouys.com/' } }} />

      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Chinese%20cinema%20atmosphere%20with%20warm%20theater%20curtains%20and%20film%20projector%20light%20beam%2C%20dark%20background%20with%20golden%20accents%2C%20luxurious%20movie%20theater%20interior%20style%2C%20cinematic%20atmosphere%2C%20elegant%20and%20artistic&width=1800&height=900&seq=hero-bg-home-01&orientation=landscape"
            alt="麻豆影视在线观看 - 高清电影电视剧免费在线播放平台"
            title="麻豆影视在线观看"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 w-full text-center px-4 md:px-6">
            <div className="max-w-[800px] mx-auto">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
                海量影视 · 免费在线观看
              </h2>
              <p className="text-base md:text-lg text-background-200 mb-8 max-w-[600px] mx-auto leading-relaxed">
                麻豆影视在线观看平台，汇集最新电影、热门电视剧、高分动漫、精彩综艺。即点即播无需下载，高清流畅不缓冲。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/action"
                  className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  开始观影
                </Link>
                <Link
                  to="/category/scifi"
                  className="px-8 py-3 rounded-lg border border-background-300/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  热门推荐
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">影视分类</h3>
              <Link to="/category/action" className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Videos */}
        <section className="py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">热门推荐</h3>
                <span className="px-2.5 py-0.5 rounded-md bg-primary-100 text-primary-600 text-xs font-medium whitespace-nowrap">
                  HOT
                </span>
              </div>
              <Link to="/category/action" className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                更多 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop>
              {hotVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* New Videos */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">最新上架</h3>
                <span className="px-2.5 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                  NEW
                </span>
              </div>
              <Link to="/category/comedy" className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                更多 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4" data-product-shop>
              {newVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-10 md:py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">影视资讯</h3>
              <a href="#" className="text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                更多 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-8">
              常见问题
            </h3>
            <SchemaOrg type="FAQPage" data={{ mainEntity: [
              { '@type': 'Question', name: '麻豆影视在线观看需要下载播放器吗？', acceptedAnswer: { '@type': 'Answer', text: '不需要。麻豆影视在线观看平台支持即点即播，无需下载任何播放器或插件，打开网页即可流畅观看高清视频。' } },
              { '@type': 'Question', name: '麻豆影视在线观看的视频资源更新频率如何？', acceptedAnswer: { '@type': 'Answer', text: '麻豆影视在线观看每天都会更新最新的电影、电视剧、动漫和综艺资源，确保用户能第一时间观看到最新热播内容。' } },
              { '@type': 'Question', name: '在线看电影电视剧需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '麻豆影视在线观看平台上的所有视频资源均为免费观看，无需付费或订阅会员，真正做到让每个人都能享受优质的影视内容。' } },
              { '@type': 'Question', name: '在线影视视频播放卡顿怎么办？', acceptedAnswer: { '@type': 'Answer', text: '麻豆影视在线观看采用先进的视频传输技术，支持高清流畅播放。如遇卡顿，建议检查网络连接或切换至较低清晰度。我们的服务器遍布全国，确保流畅不缓冲的观影体验。' } },
              { '@type': 'Question', name: '麻豆影视在线观看支持哪些设备？', acceptedAnswer: { '@type': 'Answer', text: '麻豆影视在线观看支持电脑、平板、手机等多种设备。只需使用浏览器访问网站，即可随时随地享受在线看电影电视剧的乐趣，无需下载任何App。' } },
            ] }} />
            <div className="space-y-3">
              {[
                { q: '麻豆影视在线观看需要下载播放器吗？', a: '不需要。麻豆影视在线观看平台支持即点即播，无需下载任何播放器或插件，打开网页即可流畅观看高清视频。' },
                { q: '麻豆影视在线观看的视频资源更新频率如何？', a: '麻豆影视在线观看每天都会更新最新的电影、电视剧、动漫和综艺资源，确保用户能第一时间观看到最新热播内容。' },
                { q: '在线看电影电视剧需要付费吗？', a: '麻豆影视在线观看平台上的所有视频资源均为免费观看，无需付费或订阅会员，真正做到让每个人都能享受优质的影视内容。' },
                { q: '在线影视视频播放卡顿怎么办？', a: '麻豆影视在线观看采用先进的视频传输技术，支持高清流畅播放。如遇卡顿，建议检查网络连接或切换至较低清晰度。我们的服务器遍布全国，确保流畅不缓冲的观影体验。' },
                { q: '麻豆影视在线观看支持哪些设备？', a: '麻豆影视在线观看支持电脑、平板、手机等多种设备。只需使用浏览器访问网站，即可随时随地享受在线看电影电视剧的乐趣，无需下载任何App。' },
              ].map((faq, i) => (
                <details key={i} className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-14 md:py-20 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20ambient%20home%20theater%20setup%20with%20large%20screen%20displaying%20colorful%20abstract%20visual%2C%20cozy%20atmosphere%2C%20soft%20lighting%2C%20modern%20living%20room%20with%20plants%2C%20cinematic%20vibe&width=1800&height=600&seq=cta-bg-home-01&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          <div className="relative z-10 text-center px-4 md:px-6">
            <h3 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
              开始您的观影之旅
            </h3>
            <p className="text-sm md:text-base text-background-200 mb-8 max-w-[500px] mx-auto leading-relaxed">
              数千部高清电影、热播电视剧、精彩动漫，尽在麻豆影视在线观看。无需注册，即点即播！
            </p>
            <Link
              to="/category/action"
              className="inline-flex px-8 py-3 rounded-lg bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即观看
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}